import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PlanoService } from 'src/app/service/plano.service';
import { SegmentoService } from 'src/app/service/segmento.service';
import { FuncionalidadeService } from 'src/app/service/funcionalidade.service';
import { Segmento } from 'src/app/page/segmento/segmento';
import { Funcionalidade } from 'src/app/page/funcionalidade/funcionalidade';
import { Plano } from './plano';

@Component({
  selector: 'app-plano-form',
  templateUrl: './plano-form.component.html',
  styleUrls: ['./plano-shared.scss'],
})
export class PlanoFormComponent implements OnInit {

  formulario: FormGroup;
  carregando = false;
  sincronizandoWowve = false;
  segmentos: Segmento[] = [];
  funcionalidades: Funcionalidade[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private planoService: PlanoService,
    private segmentoService: SegmentoService,
    private funcionalidadeService: FuncionalidadeService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.carregarSegmentos();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  montarFormulario() {
    this.formulario = this.formBuilder.group({
      id: [null],
      nome: [null, Validators.required],
      segmentoId: [null, Validators.required],
      valorBase: [null, Validators.required],
      taxaAdesao: [null],
      situacao: [true],
      funcionalidadeIds: [[]],
      wowveId: [{ value: null, disabled: true }],
    });

    this.formulario.get('segmentoId')?.valueChanges.subscribe((segmentoId: number | null) => {
      this.carregarFuncionalidades(segmentoId);
      this.formulario.get('funcionalidadeIds')?.setValue([]);
    });
  }

  carregarSegmentos() {
    this.segmentoService.listarAtivos().subscribe(resp => this.segmentos = resp ?? []);
  }

  carregarFuncionalidades(segmentoId: number | null) {
    if (!segmentoId) {
      this.funcionalidades = [];
      return;
    }
    this.funcionalidadeService.listarAtivas(segmentoId).subscribe(resp => this.funcionalidades = resp ?? []);
  }

  carregar(id: number) {
    this.carregando = true;
    this.planoService.getById(id).subscribe(response => {
      this.carregarFuncionalidades(response.segmentoId);
      this.formulario.patchValue({
        id: response.id,
        nome: response.nome,
        segmentoId: response.segmentoId,
        valorBase: response.valorBase,
        taxaAdesao: response.taxaAdesao,
        situacao: response.situacao,
      }, { emitEvent: false });
      this.formulario.get('funcionalidadeIds')?.setValue(response.funcionalidadeIds ?? [], { emitEvent: false });
      this.formulario.get('wowveId')?.setValue(response.wowveId ?? null, { emitEvent: false });
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Plano não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  submit() {
    const formValues = this.formulario.value;
    const plano = new Plano(
      formValues.id,
      formValues.nome,
      formValues.segmentoId,
      formValues.valorBase,
      formValues.taxaAdesao,
      formValues.situacao,
      formValues.funcionalidadeIds ?? [],
    );

    const request = formValues.id
      ? this.planoService.update(plano)
      : this.planoService.save(plano);

    request.subscribe(() => {
      this.snackBar.open(
        formValues.id ? 'Plano atualizado com sucesso!' : 'Plano salvo com sucesso!',
        'Sucesso',
        { duration: 2000 },
      );
      this.voltarConsulta();
    }, error => {
      this.snackBar.open(error.error?.message ?? 'Erro ao salvar plano.', 'ERRO', { duration: 2000 });
    });
  }

  get segmentoWowVe(): boolean {
    const segmentoId = this.formulario?.get('segmentoId')?.value;
    const seg = this.segmentos.find(s => s.id === segmentoId);
    return seg?.codigo?.toUpperCase() === 'WOW_VE';
  }

  sincronizarWowve() {
    const id = this.formulario?.get('id')?.value;
    if (!id) {
      this.snackBar.open('Salve o plano antes de sincronizar com o WOW.ve.', 'ERRO', { duration: 3000 });
      return;
    }
    this.sincronizandoWowve = true;
    this.planoService.sincronizarWowve(id).subscribe(plano => {
      this.formulario.get('wowveId')?.setValue(plano.wowveId ?? null);
      this.sincronizandoWowve = false;
      this.snackBar.open('Plano sincronizado com o WOW.ve com sucesso!', 'OK', { duration: 3000 });
    }, err => {
      this.sincronizandoWowve = false;
      this.snackBar.open(err.error?.message ?? 'Erro ao sincronizar plano no WOW.ve.', 'ERRO', { duration: 4000 });
    });
  }

  limpar() {
    this.montarFormulario();
  }

  voltarConsulta() {
    this.router.navigate(['/plano/consulta']);
  }
}
